import ReactPlayer from "react-player";

const SizzleVideo = () => {
  return (
    <ReactPlayer
      muted
      url="Nasdaq-Fund-Network.mp4"
      playing={true}
      loop={true}
      controls={true}
    />
  );
};

export default SizzleVideo;
